import Vue from "vue";
import Router from "vue-router";
import { VueMaskDirective } from "v-mask";
import vueCountryRegionSelect from "vue-country-region-select";

import AuthRoutes from './auth'
import ProjectRoutes from './project'
import DashboardRoutes from './dashboard'
import PricingRoutes from './pricing'
import RedirectRoutes from './redirects'

Vue.use(vueCountryRegionSelect);
Vue.directive("mask", VueMaskDirective);
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    ...AuthRoutes,
    ...ProjectRoutes,
    ...DashboardRoutes,
    ...PricingRoutes,
    ...RedirectRoutes
  ]
});

export default router;
